/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Benefits_Item3Inputs */

const ja_playdata_home_benefits_item3 = /** @type {(inputs: Playdata_Home_Benefits_Item3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配信プラットフォーム別のイベント人気度を知りたい`)
};

const en_playdata_home_benefits_item3 = /** @type {(inputs: Playdata_Home_Benefits_Item3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want to know the popularity of events based on distribution platform`)
};

/**
* | output |
* | --- |
* | "I want to know the popularity of events based on distribution platform" |
*
* @param {Playdata_Home_Benefits_Item3Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_benefits_item3 = /** @type {((inputs?: Playdata_Home_Benefits_Item3Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Benefits_Item3Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_benefits_item3(inputs)
	return en_playdata_home_benefits_item3(inputs)
});